import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';

export interface LegalSection {
  heading: string;
  body: React.ReactNode;
  id?: string;
}

interface LegalPageLayoutProps {
  title: string;
  updated: string;
  intro?: React.ReactNode;
  sections: LegalSection[];
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, updated, intro, sections }) => (
  <Box sx={{ py: { xs: 6, md: 10 } }}>
    <Container maxWidth="md">
      <Typography variant="h2" gutterBottom sx={{ fontSize: { xs: '2rem', md: '2.75rem' } }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Last updated: {updated}
      </Typography>
      {intro && (
        <Typography color="text.secondary" sx={{ mb: 4 }}>
          {intro}
        </Typography>
      )}
      {sections.map((s, i) => (
        <Box key={i} id={s.id} sx={{ mb: 4, scrollMarginTop: '90px' }}>
          <Typography variant="h5" fontWeight={600} gutterBottom>
            {i + 1}. {s.heading}
          </Typography>
          <Typography component="div" color="text.secondary">
            {s.body}
          </Typography>
        </Box>
      ))}
      <Divider sx={{ my: 4 }} />
      <Typography variant="body2" color="text.secondary">
        Questions? Contact{' '}
        <a href="mailto:legal@debtornator.com" style={{ color: '#64b5f6' }}>
          legal@debtornator.com
        </a>
        .
      </Typography>
    </Container>
  </Box>
);

export default LegalPageLayout;
